/**
 * Opens the tour once, by itself, when a plan has no containers yet and the
 * viewer has never opened it — the Board stays one click away. Never fires
 * twice in a session, never on a plan that already has containers.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useEffect, useRef } from 'react';

import type { CountryTab } from '@/pages/admin/drop-generator/CountryTabs';

import { useTutorialProgress } from '../use-tutorial-progress';

export function useTutorialAutoOpen(args: {
  containerCount: number | undefined;
  tab: CountryTab;
  open: () => void;
}): void {
  const { hasOpened } = useTutorialProgress();
  const fired = useRef(false);
  const { containerCount, tab, open } = args;
  useEffect(() => {
    if (fired.current || hasOpened || tab !== 'board' || containerCount !== 0) return;
    fired.current = true;
    open();
  }, [hasOpened, tab, containerCount, open]);
}
